/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";

import { signInWithGoogle, auth } from "../../firebase";
import * as actions from "../../store/actions";

import GoogleButton from "../UI/GoogleButton/GoogleButton";
import Input from "../UI/Input/Input";
import Error from "../UI/Error/Error";

import classes from "./SignUp.module.css";

const SignUp = ({ setPasswordResetModal }) => {
  const [login, setLogin] = useState(true);
  const [loginError, setLoginError] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    if (login) {
      auth
        .signInWithEmailAndPassword(data.email, data.password)
        .then((user) => {
          setLoginError(null);
        })
        .catch((error) => {
          console.log("error", error);
          setLoginError(error.code);
        });
    } else {
      auth
        .createUserWithEmailAndPassword(data.email, data.password)
        .then(() => {
          auth.currentUser.sendEmailVerification();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  console.log(errors);

  return (
    <div className={classes.SignUp}>
      <h2>{login ? "Sign in to purchase" : "Create an account"}</h2>
      <div className={classes.ButtonContainer}>
        <hr />
        <GoogleButton clicked={signInWithGoogle} />
        <hr />
      </div>
      <p className={classes.Or}>or</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          type="text"
          placeholder="Email address"
          error={
            errors.email || loginError === "auth/user-not-found"
              ? "error"
              : null
          }
          {...register("email", {
            required: true,
            pattern:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          })}
        />
        {errors.email && errors.email.type === "pattern" ? (
          <Error>Please enter a valid email address.</Error>
        ) : null}
        {loginError === "auth/user-not-found" ? (
          <Error>
            The entered email address is not associated with any account.
          </Error>
        ) : null}
        <Input
          type="password"
          placeholder="Password"
          error={
            errors.password || loginError === "auth/wrong-password"
              ? "error"
              : null
          }
          {...register("password", { required: true, minLength: 6 })}
        />
        {errors.password && errors.password.type === "minLength" ? (
          <Error>Please select a longer password.</Error>
        ) : null}
        {loginError === "auth/wrong-password" ? (
          <Error>The entered password is not correct.</Error>
        ) : null}
        {(errors.email && errors.email.type === "required") ||
        (errors.password && errors.password.type === "required") ? (
          <Error>Please fill in all the required fields.</Error>
        ) : null}
        <button type="submit">{login ? "Sign in" : "Sign up"}</button>
      </form>
      {login ? (
        <>
          <p>
            Don’t have an account?{" "}
            <button className={classes.Link} onClick={() => setLogin(false)}>
              Sign up
            </button>
            !
          </p>
          <p>
            <button
              className={classes.Link}
              onClick={() => setPasswordResetModal(true)}
            >
              Forgot your password?
            </button>
          </p>
        </>
      ) : (
        <>
          <p>
            Already have an account?{" "}
            <button className={classes.Link} onClick={() => setLogin(true)}>
              Sign in
            </button>
            !
          </p>
          <p>
            By creating an account, you agree to Art Prompts’{" "}
            <a href="/#">Privacy Policy</a> and <a href="/#">Terms of Use</a>.
          </p>
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setPasswordResetModal: (show) =>
    dispatch(actions.setPasswordResetModal(show)),
});

export default connect(null, mapDispatchToProps)(SignUp);
